import {
	CustomerCreateInput,
	CustomerCreatePayload,
	CustomerAccessTokenCreateInput,
	CustomerAccessTokenCreatePayload,
	CustomerAccessTokenDeletePayload,
	CustomerRecoverPayload,
	CustomerResetByUrlPayload,
} from '@local/types/storefront-api-types'
import {fetchWithLocale, postWithLocale} from '../useShopifyStore'

export interface ShopifyCustomerAuthProps {
	exist: (email: string) => Promise<any | null>,
	signUp: (input: CustomerCreateInput, gender?: string, birthdate?: string) => Promise<CustomerCreatePayload>,
	signIn: (input: CustomerAccessTokenCreateInput) => Promise<CustomerAccessTokenCreatePayload>,
	signOut: (options?: {noInvalidateToken?: boolean}) => Promise<CustomerAccessTokenDeletePayload>,
	sendPasswordRecover: (email: string) => Promise<CustomerRecoverPayload>,
	resetPassword: (resetUrl: string, password: string) => Promise<CustomerResetByUrlPayload>,
	activate: (activateUrl: string, password: string) => Promise<any>,
}

export const shopifyCustomerAuthStore = (set, get, store): ShopifyCustomerAuthProps => ({
	signUp: async (input: CustomerCreateInput) => {
		set({loading: true})

		const result = await postWithLocale('/api/shopify/auth/create', {input})

		// auto login
		if (!result?.customerUserErrors?.length) {
			await get().signIn({email: input.email, password: input.password, preventDetailFetching: true})
		} else {
			set({loading: true})
		}

		return result
	},

	exist: async (email) => {
		set({loading: true})
		const result = await fetchWithLocale('/api/shopify/auth/exist', {searchParams: {email}})
		set({loading: false})

		return result
	},

	signIn: async ({email, password}: CustomerAccessTokenCreateInput) => {
		set({loading: true})
		const result = await postWithLocale('/api/shopify/auth/sign-in', {email, password})

		if (!result?.customerUserErrors?.length) {
			// set customer identity
			const customerAccessToken = result?.customerAccessToken || null
			set({customerAccessToken})

			// get details at sign in
			await get().getDetails()
		}

		set({loading: false})

		return result
	},

	signOut: async ({noInvalidateToken} = {}) => {
		set({loading: true})

		const result = await fetchWithLocale('/api/shopify/auth/sign-out', {searchParams: {noInvalidateToken}})

		set({
			customer: undefined,
			referralLink: undefined,
			customerAccessToken: undefined,
			// orders: undefined,
			loading: false,
		})

		return result
	},

	sendPasswordRecover: async (email) => {
		set({loading: true})
		const result = await postWithLocale('/api/shopify/recover', {email})
		set({loading: false})
		return result
	},

	resetPassword: async (resetUrl, password) => {
		set({loading: true})
		const result = await postWithLocale('/api/shopify/auth/reset', {resetUrl, password})
		set({loading: false})
		return result
	},

	activate: async (activationUrl, password) => {
		set({loading: true})
		const result = await postWithLocale('/api/shopify/auth/activate', {activationUrl, password})
		set({loading: false})
		return result
	},
})
